"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UaFactory = void 0;
var common_ua_1 = __importDefault(require("./common-ua"));
var UaFactory = /** @class */ (function () {
    function UaFactory() {
    }
    UaFactory.createUa = function () {
        return common_ua_1.default;
    };
    return UaFactory;
}());
exports.UaFactory = UaFactory;
exports.default = UaFactory.createUa();
